import React, { Fragment } from 'react'
import 'ta-semantic-ui/semantic/dist/components/card.css'
import 'ta-semantic-ui/semantic/dist/components/table.css'
import s from './hotel.m.scss'
import { Property } from './components/property'
import { TopImage } from './components/topImage'
import clsx from 'clsx'
import { ExternalLinkIcon } from 'components/linkIcons'
import { ColourVariation } from 'lib/colourVariation'

interface Props {
  address: string
  colors: ColourVariation
  className?: string
  description: string
  host?: string
  image: string
  name: string
  phone: string
  previousRank: string
  price: string
  rank: number
  stars: number
  typeOfStay: string
  website: string
  winnerText?: string
}

export function Hotel({
  stars,
  website,
  colors,
  image,
  winnerText,
  rank,
  previousRank,
  name,
  description,
  address,
  phone,
  host,
  typeOfStay,
  price,
  className = ''
}: Props) {
  // we're totally using array destructuring here, how fancy!
  const [hotelName, place] = name.split(', ')

  return (
    <a
      href={`http://${website}`}
      className={clsx('ui link card', 'hotel', className)}
      style={{ position: 'relative' }}
    >
      <TopImage
        current={rank}
        previous={previousRank}
        colours={colors}
        imageName={image}
      />

      <div className='content'>
        <h3 className={clsx(s.header, rank > 10 && s.small)}>
          <div className={s.nameAndStars}>
            <div className={s.name}>{hotelName}</div>
          </div>
          <div className={clsx(s.placename)}>{place}</div>
          <div className={s.subHeader}>{description}</div>
        </h3>
        <div className={clsx('mobile only', s.winnerText)}>{winnerText}</div>
      </div>

      <table
        className={clsx(
          'ui fixed small very compact definition attached unstackable striped table',
          s.transparentBackground
        )}
      >
        <tbody>
          <Property keyName='Adresse'>
            {address.split(', ').map((line, index) => {
              if (index === 0) return <Fragment key={index}>{line}</Fragment>

              return (
                <Fragment key={index}>
                  <br />
                  {line}
                </Fragment>
              )
            })}
          </Property>

          <Property keyName='Telefon'>{phone}</Property>

          <Property keyName='Website'>
            <a href={`http://${website}`}>
              <ExternalLinkIcon />
              {website}
            </a>
          </Property>

          {host && host.length > 0 && (
            <Property keyName='Gastgeber'>{host}</Property>
          )}

          <Property keyName={typeOfStay}>{price}</Property>
        </tbody>
      </table>
    </a>
  )
}
